/* About us page motion (sections/pp-about-page.liquid, styles in pp-about.css).
   - [data-split]    headline words rise out of a clipped box, one after another
   - [data-scramble] the small label types itself in from random characters
   - [data-fade]     blocks fade up; data-delay (ms) staggers them
   Hero items start on load, everything else when it scrolls into view. Without JS, or with reduced motion,
   everything is simply visible. */
(function () {
  'use strict';
  var root = document.querySelector('.ppa');
  if (!root) return;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var CHARS = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';

  /* Split a headline into word boxes. Text nodes are split on spaces; elements (the leaf icon) get a box of their own. */
  function splitWords(el) {
    var index = 0;
    function box(node) {
      var w = document.createElement('span');
      w.className = 'w';
      var inner = document.createElement('span');
      inner.style.setProperty('--i', index++);
      inner.appendChild(node);
      w.appendChild(inner);
      return w;
    }
    Array.prototype.slice.call(el.childNodes).forEach(function (node) {
      if (node.nodeType === 3) {
        var frag = document.createDocumentFragment();
        node.textContent.split(/(\s+)/).forEach(function (part) {
          if (!part) return;
          if (/^\s+$/.test(part)) frag.appendChild(document.createTextNode(' '));
          else frag.appendChild(box(document.createTextNode(part)));
        });
        el.replaceChild(frag, node);
      } else if (node.nodeType === 1 && node.nodeName === 'BR') {
        /* a line break stays where it is */
      } else if (node.nodeType === 1) {
        var wrapped = box(node.cloneNode(true));
        el.replaceChild(wrapped, node);
      }
    });
  }

  function scramble(span) {
    var final = span.getAttribute('data-final');
    if (reduce) { span.textContent = final; return; }
    var duration = 700, start = performance.now();
    (function tick(now) {
      var t = Math.min(1, (now - start) / duration);
      var keep = Math.floor(t * final.length), out = final.slice(0, keep);
      for (var i = keep; i < final.length; i++) {
        out += final[i] === ' ' ? ' ' : CHARS[Math.floor(Math.random() * CHARS.length)];
      }
      span.textContent = out;
      if (t < 1) requestAnimationFrame(tick);
      else span.textContent = final;
    })(start);
  }

  function reveal(el, extraDelay) {
    var delay = (extraDelay || 0) + (parseInt(el.getAttribute('data-delay'), 10) || 0);
    setTimeout(function () {
      if (el.hasAttribute('data-scramble')) scramble(el);
      else el.classList.add('is-in');
    }, delay);
  }

  var splits = root.querySelectorAll('[data-split]');
  Array.prototype.forEach.call(splits, splitWords);

  var scrambles = root.querySelectorAll('[data-scramble]');
  Array.prototype.forEach.call(scrambles, function (s) {
    s.setAttribute('data-final', s.textContent.trim());
    if (!reduce) s.textContent = '';
  });

  var targets = root.querySelectorAll('[data-split],[data-fade],[data-scramble]');

  if (reduce || !('IntersectionObserver' in window)) {
    Array.prototype.forEach.call(targets, function (el) {
      if (el.hasAttribute('data-scramble')) el.textContent = el.getAttribute('data-final');
      else el.classList.add('is-in');
    });
  } else {
    var hero = root.querySelector('.ppa-hero');
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        io.unobserve(e.target);
        reveal(e.target, 0);
      });
    }, { threshold: 0.2, rootMargin: '0px 0px -8% 0px' });
    Array.prototype.forEach.call(targets, function (el) {
      if (hero && hero.contains(el)) {
        /* hero: label first, then the headline (data-start), then the rest by data-delay */
        var start = el.hasAttribute('data-scramble') ? 250 : (parseInt(el.getAttribute('data-start'), 10) || 0);
        reveal(el, start);
      } else {
        io.observe(el);
      }
    });
  }

  /* Accordion: one item open at a time */
  var items = root.querySelectorAll('.ppa-acc__item');
  Array.prototype.forEach.call(items, function (item) {
    var head = item.querySelector('.ppa-acc__head');
    head.addEventListener('click', function () {
      var open = !item.classList.contains('is-open');
      Array.prototype.forEach.call(items, function (other) {
        other.classList.remove('is-open');
        other.querySelector('.ppa-acc__head').setAttribute('aria-expanded', 'false');
      });
      if (open) {
        item.classList.add('is-open');
        head.setAttribute('aria-expanded', 'true');
      }
    });
  });

  /* Photo strip: side scroll with trackpad, touch or by dragging with the mouse */
  var strip = root.querySelector('.ppa-marquee');
  if (strip) {
    var down = false, startX = 0, startLeft = 0, moved = false;
    strip.addEventListener('mousedown', function (e) { down = true; moved = false; startX = e.pageX; startLeft = strip.scrollLeft; });
    window.addEventListener('mouseup', function () { down = false; strip.classList.remove('is-drag'); });
    window.addEventListener('mousemove', function (e) {
      if (!down) return;
      var dx = e.pageX - startX;
      if (Math.abs(dx) > 3) { moved = true; strip.classList.add('is-drag'); }
      strip.scrollLeft = startLeft - dx;
    });
    strip.addEventListener('dragstart', function (e) { e.preventDefault(); });
  }

  /* Some phones (low power mode) block autoplay: the poster stays, and a start is retried once the video scrolls into view or the page is touched */
  var vids = root.querySelectorAll('video');
  function tryPlay(v) { if (v.paused && !v.hasAttribute('data-user-paused')) { var pr = v.play(); if (pr && pr.catch) pr.catch(function () {}); } }
  Array.prototype.forEach.call(vids, function (v) {
    v.muted = true;
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) tryPlay(v); }); }, { threshold: 0.2 }).observe(v);
    }
    window.addEventListener('touchstart', function () { tryPlay(v); }, { once: true, passive: true });
  });

  /* Pause buttons for the two videos */
  Array.prototype.forEach.call(root.querySelectorAll('[data-pause]'), function (btn) {
    var video = btn.parentNode.querySelector('video');
    if (!video) return;
    btn.addEventListener('click', function () {
      if (video.paused) { video.removeAttribute('data-user-paused'); video.play(); btn.classList.remove('is-paused'); btn.setAttribute('aria-label', 'Pause video'); }
      else { video.setAttribute('data-user-paused', '1'); video.pause(); btn.classList.add('is-paused'); btn.setAttribute('aria-label', 'Play video'); }
    });
  });
})();
